/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminChatLogsResponse } from '../models';
// @ts-ignore
import type { AdminInitiateSupportBody } from '../models';
// @ts-ignore
import type { AdminSupportChatMessageListResponse } from '../models';
// @ts-ignore
import type { BulkTemplateSupportBody } from '../models';
// @ts-ignore
import type { BulkTemplateSupportResponse } from '../models';
// @ts-ignore
import type { ChatBlockStatusBody } from '../models';
// @ts-ignore
import type { ChatBlockStatusResponse } from '../models';
// @ts-ignore
import type { ChatGroupResponse } from '../models';
// @ts-ignore
import type { ChatMessageBody } from '../models';
// @ts-ignore
import type { ChatMessageListResponse } from '../models';
// @ts-ignore
import type { ChatMessageResponse } from '../models';
// @ts-ignore
import type { CreateChatGroupBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetChatGroupUsersResponse } from '../models';
// @ts-ignore
import type { GetEmployerListResponse } from '../models';
// @ts-ignore
import type { GetLatestChatCount } from '../models';
// @ts-ignore
import type { GroupChatListResponse } from '../models';
// @ts-ignore
import type { LatestChatListResponse } from '../models';
// @ts-ignore
import type { MarkSeenChatBody } from '../models';
// @ts-ignore
import type { SendMsgOrgOwnerBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { SupportChatCount } from '../models';
// @ts-ignore
import type { SupportChatListResponse } from '../models';
// @ts-ignore
import type { UpdateChatGroupBody } from '../models';
// @ts-ignore
import type { UpdateChatMessageBody } from '../models';
/**
 * ChatApiApi - axios parameter creator
 */
export const ChatApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} employerId 
         * @param {string} orgId 
         * @param {AdminInitiateSupportBody} adminInitiateSupportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiAdminInitiateChatSupport: async (employerId: string, orgId: string, adminInitiateSupportBody: AdminInitiateSupportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employerId' is not null or undefined
            assertParamExists('chatApiAdminInitiateChatSupport', 'employerId', employerId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiAdminInitiateChatSupport', 'orgId', orgId)
            // verify required parameter 'adminInitiateSupportBody' is not null or undefined
            assertParamExists('chatApiAdminInitiateChatSupport', 'adminInitiateSupportBody', adminInitiateSupportBody)
            const localVarPath = `/admin/org/{org_id}/chat/employer/{employer_id}/initiate-support`
                .replace('{employer_id}', encodeURIComponent(String(employerId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInitiateSupportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiAssignChatGroupAdmin: async (groupId: string, memberUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('chatApiAssignChatGroupAdmin', 'groupId', groupId)
            // verify required parameter 'memberUserId' is not null or undefined
            assertParamExists('chatApiAssignChatGroupAdmin', 'memberUserId', memberUserId)
            const localVarPath = `/chat/group/{group_id}/assign-admin/{member_user_id}`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{member_user_id}', encodeURIComponent(String(memberUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateChatGroupBody} createChatGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiCreateChatGroup: async (orgId: string, createChatGroupBody: CreateChatGroupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiCreateChatGroup', 'orgId', orgId)
            // verify required parameter 'createChatGroupBody' is not null or undefined
            assertParamExists('chatApiCreateChatGroup', 'createChatGroupBody', createChatGroupBody)
            const localVarPath = `/org/{org_id}/chat/group`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiDeleteChatMsg: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('chatApiDeleteChatMsg', 'chatId', chatId)
            const localVarPath = `/chat/{chat_id}`
                .replace('{chat_id}', encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiExitChatGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('chatApiExitChatGroup', 'groupId', groupId)
            const localVarPath = `/chat/group/{group_id}/exit`
                .replace('{group_id}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAccountSupportChat: async (pageNo?: number | null, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAccountSupportCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/support/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [companyName] 
         * @param {boolean | null} [isResolved] 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [supportChatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAdminSupportChatMessage: async (companyName?: string | null, isResolved?: boolean | null, pageNo?: number | null, pageSize?: number | null, supportChatId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/chat/support-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }

            if (isResolved !== undefined) {
                localVarQueryParameter['is_resolved'] = isResolved;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (supportChatId !== undefined) {
                localVarQueryParameter['support_chat_id'] = supportChatId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAdminSupportCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/chat/support-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatCount: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiGetChatCount', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat/count`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatGroup: async (pageNo?: number | null, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatGroupUsers: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('chatApiGetChatGroupUsers', 'groupId', groupId)
            const localVarPath = `/chat/group/{group_id}/users`
                .replace('{group_id}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatLogsEmployerApplicant: async (page?: number | null, pageSize?: number | null, searchQuery?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/chat-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [chatGroupId] 
         * @param {string | null} [cursor] 
         * @param {string | null} [gameId] 
         * @param {string | null} [jobId] 
         * @param {string | null} [orgId] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [roomId] 
         * @param {string | null} [supportChatId] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatMessage: async (chatGroupId?: string | null, cursor?: string | null, gameId?: string | null, jobId?: string | null, orgId?: string | null, pageSize?: number | null, roomId?: string | null, supportChatId?: string | null, userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (chatGroupId !== undefined) {
                localVarQueryParameter['chat_group_id'] = chatGroupId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (gameId !== undefined) {
                localVarQueryParameter['game_id'] = gameId;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (roomId !== undefined) {
                localVarQueryParameter['room_id'] = roomId;
            }

            if (supportChatId !== undefined) {
                localVarQueryParameter['support_chat_id'] = supportChatId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [companyName] 
         * @param {string | null} [email] 
         * @param {string | null} [employerId] 
         * @param {string | null} [name] 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetEmployerList: async (companyName?: string | null, email?: string | null, employerId?: string | null, name?: string | null, pageNo?: number | null, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/chat/employers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (employerId !== undefined) {
                localVarQueryParameter['employer_id'] = employerId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetFrontChatList: async (orgId: string, pageNo?: number | null, pageSize?: number | null, searchQuery?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiGetFrontChatList', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetSupportChat: async (orgId: string, pageNo?: number | null, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiGetSupportChat', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat/support`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiInitiateChatSupport: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiInitiateChatSupport', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat/initiate-support`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkSeenChatBody} markSeenChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiMarkChatSeen: async (markSeenChatBody: MarkSeenChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markSeenChatBody' is not null or undefined
            assertParamExists('chatApiMarkChatSeen', 'markSeenChatBody', markSeenChatBody)
            const localVarPath = `/chat/mark-seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markSeenChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} supportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiResolveSupportChat: async (supportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportId' is not null or undefined
            assertParamExists('chatApiResolveSupportChat', 'supportId', supportId)
            const localVarPath = `/admin/chat/support/{support_id}/resolved`
                .replace('{support_id}', encodeURIComponent(String(supportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChatBlockStatusBody} chatBlockStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendBlockChatStatus: async (chatBlockStatusBody: ChatBlockStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatBlockStatusBody' is not null or undefined
            assertParamExists('chatApiSendBlockChatStatus', 'chatBlockStatusBody', chatBlockStatusBody)
            const localVarPath = `/chat/block-unblock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatBlockStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkTemplateSupportBody} bulkTemplateSupportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendBulkTemplateMessagesByAdmin: async (bulkTemplateSupportBody: BulkTemplateSupportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkTemplateSupportBody' is not null or undefined
            assertParamExists('chatApiSendBulkTemplateMessagesByAdmin', 'bulkTemplateSupportBody', bulkTemplateSupportBody)
            const localVarPath = `/admin/chat/employer/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkTemplateSupportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChatMessageBody} chatMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendChatMessage: async (chatMessageBody: ChatMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatMessageBody' is not null or undefined
            assertParamExists('chatApiSendChatMessage', 'chatMessageBody', chatMessageBody)
            const localVarPath = `/chat/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendMsgOrgOwnerBody} sendMsgOrgOwnerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendMsgOrgOwner: async (sendMsgOrgOwnerBody: SendMsgOrgOwnerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendMsgOrgOwnerBody' is not null or undefined
            assertParamExists('chatApiSendMsgOrgOwner', 'sendMsgOrgOwnerBody', sendMsgOrgOwnerBody)
            const localVarPath = `/admin/chat/org_owner/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMsgOrgOwnerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiUnassignChatGroupAdmin: async (groupId: string, memberUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('chatApiUnassignChatGroupAdmin', 'groupId', groupId)
            // verify required parameter 'memberUserId' is not null or undefined
            assertParamExists('chatApiUnassignChatGroupAdmin', 'memberUserId', memberUserId)
            const localVarPath = `/chat/group/{group_id}/unassign-admin/{member_user_id}`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{member_user_id}', encodeURIComponent(String(memberUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {UpdateChatGroupBody} updateChatGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiUpdateChatGroup: async (groupId: string, orgId: string, updateChatGroupBody: UpdateChatGroupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('chatApiUpdateChatGroup', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('chatApiUpdateChatGroup', 'orgId', orgId)
            // verify required parameter 'updateChatGroupBody' is not null or undefined
            assertParamExists('chatApiUpdateChatGroup', 'updateChatGroupBody', updateChatGroupBody)
            const localVarPath = `/org/{org_id}/chat/group/{group_id}`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChatGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {UpdateChatMessageBody} updateChatMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiUpdateChatMsg: async (chatId: string, updateChatMessageBody: UpdateChatMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('chatApiUpdateChatMsg', 'chatId', chatId)
            // verify required parameter 'updateChatMessageBody' is not null or undefined
            assertParamExists('chatApiUpdateChatMsg', 'updateChatMessageBody', updateChatMessageBody)
            const localVarPath = `/chat/{chat_id}`
                .replace('{chat_id}', encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChatMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApiApi - functional programming interface
 */
export const ChatApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} employerId 
         * @param {string} orgId 
         * @param {AdminInitiateSupportBody} adminInitiateSupportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiAdminInitiateChatSupport(employerId: string, orgId: string, adminInitiateSupportBody: AdminInitiateSupportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiAdminInitiateChatSupport(employerId, orgId, adminInitiateSupportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiAdminInitiateChatSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiAssignChatGroupAdmin(groupId: string, memberUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiAssignChatGroupAdmin(groupId, memberUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiAssignChatGroupAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateChatGroupBody} createChatGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiCreateChatGroup(orgId: string, createChatGroupBody: CreateChatGroupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiCreateChatGroup(orgId, createChatGroupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiCreateChatGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiDeleteChatMsg(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiDeleteChatMsg(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiDeleteChatMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiExitChatGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiExitChatGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiExitChatGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetAccountSupportChat(pageNo?: number | null, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportChatListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetAccountSupportChat(pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetAccountSupportChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetAccountSupportCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestChatCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetAccountSupportCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetAccountSupportCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [companyName] 
         * @param {boolean | null} [isResolved] 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [supportChatId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetAdminSupportChatMessage(companyName?: string | null, isResolved?: boolean | null, pageNo?: number | null, pageSize?: number | null, supportChatId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSupportChatMessageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetAdminSupportChatMessage(companyName, isResolved, pageNo, pageSize, supportChatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetAdminSupportChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetAdminSupportCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportChatCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetAdminSupportCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetAdminSupportCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetChatCount(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestChatCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetChatCount(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetChatCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetChatGroup(pageNo?: number | null, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupChatListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetChatGroup(pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetChatGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetChatGroupUsers(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChatGroupUsersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetChatGroupUsers(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetChatGroupUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetChatLogsEmployerApplicant(page?: number | null, pageSize?: number | null, searchQuery?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminChatLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetChatLogsEmployerApplicant(page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetChatLogsEmployerApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [chatGroupId] 
         * @param {string | null} [cursor] 
         * @param {string | null} [gameId] 
         * @param {string | null} [jobId] 
         * @param {string | null} [orgId] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [roomId] 
         * @param {string | null} [supportChatId] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetChatMessage(chatGroupId?: string | null, cursor?: string | null, gameId?: string | null, jobId?: string | null, orgId?: string | null, pageSize?: number | null, roomId?: string | null, supportChatId?: string | null, userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetChatMessage(chatGroupId, cursor, gameId, jobId, orgId, pageSize, roomId, supportChatId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [companyName] 
         * @param {string | null} [email] 
         * @param {string | null} [employerId] 
         * @param {string | null} [name] 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetEmployerList(companyName?: string | null, email?: string | null, employerId?: string | null, name?: string | null, pageNo?: number | null, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployerListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetEmployerList(companyName, email, employerId, name, pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetEmployerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetFrontChatList(orgId: string, pageNo?: number | null, pageSize?: number | null, searchQuery?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestChatListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetFrontChatList(orgId, pageNo, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetFrontChatList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiGetSupportChat(orgId: string, pageNo?: number | null, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportChatListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiGetSupportChat(orgId, pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiGetSupportChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiInitiateChatSupport(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiInitiateChatSupport(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiInitiateChatSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkSeenChatBody} markSeenChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiMarkChatSeen(markSeenChatBody: MarkSeenChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiMarkChatSeen(markSeenChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiMarkChatSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} supportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiResolveSupportChat(supportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiResolveSupportChat(supportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiResolveSupportChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChatBlockStatusBody} chatBlockStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiSendBlockChatStatus(chatBlockStatusBody: ChatBlockStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatBlockStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiSendBlockChatStatus(chatBlockStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiSendBlockChatStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkTemplateSupportBody} bulkTemplateSupportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiSendBulkTemplateMessagesByAdmin(bulkTemplateSupportBody: BulkTemplateSupportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkTemplateSupportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiSendBulkTemplateMessagesByAdmin(bulkTemplateSupportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiSendBulkTemplateMessagesByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChatMessageBody} chatMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiSendChatMessage(chatMessageBody: ChatMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiSendChatMessage(chatMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiSendChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendMsgOrgOwnerBody} sendMsgOrgOwnerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiSendMsgOrgOwner(sendMsgOrgOwnerBody: SendMsgOrgOwnerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMessageResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiSendMsgOrgOwner(sendMsgOrgOwnerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiSendMsgOrgOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} memberUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiUnassignChatGroupAdmin(groupId: string, memberUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiUnassignChatGroupAdmin(groupId, memberUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiUnassignChatGroupAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {UpdateChatGroupBody} updateChatGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiUpdateChatGroup(groupId: string, orgId: string, updateChatGroupBody: UpdateChatGroupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChatGroupUsersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiUpdateChatGroup(groupId, orgId, updateChatGroupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiUpdateChatGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {UpdateChatMessageBody} updateChatMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatApiUpdateChatMsg(chatId: string, updateChatMessageBody: UpdateChatMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatApiUpdateChatMsg(chatId, updateChatMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApiApi.chatApiUpdateChatMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApiApi - factory interface
 */
export const ChatApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatApiApiChatApiAdminInitiateChatSupportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiAdminInitiateChatSupport(requestParameters: ChatApiApiChatApiAdminInitiateChatSupportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.chatApiAdminInitiateChatSupport(requestParameters.employerId, requestParameters.orgId, requestParameters.adminInitiateSupportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiAssignChatGroupAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiAssignChatGroupAdmin(requestParameters: ChatApiApiChatApiAssignChatGroupAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.chatApiAssignChatGroupAdmin(requestParameters.groupId, requestParameters.memberUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiCreateChatGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiCreateChatGroup(requestParameters: ChatApiApiChatApiCreateChatGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatGroupResponse> {
            return localVarFp.chatApiCreateChatGroup(requestParameters.orgId, requestParameters.createChatGroupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiDeleteChatMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiDeleteChatMsg(requestParameters: ChatApiApiChatApiDeleteChatMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.chatApiDeleteChatMsg(requestParameters.chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiExitChatGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiExitChatGroup(requestParameters: ChatApiApiChatApiExitChatGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.chatApiExitChatGroup(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetAccountSupportChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAccountSupportChat(requestParameters: ChatApiApiChatApiGetAccountSupportChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SupportChatListResponse> {
            return localVarFp.chatApiGetAccountSupportChat(requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAccountSupportCount(options?: RawAxiosRequestConfig): AxiosPromise<GetLatestChatCount> {
            return localVarFp.chatApiGetAccountSupportCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetAdminSupportChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAdminSupportChatMessage(requestParameters: ChatApiApiChatApiGetAdminSupportChatMessageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminSupportChatMessageListResponse> {
            return localVarFp.chatApiGetAdminSupportChatMessage(requestParameters.companyName, requestParameters.isResolved, requestParameters.pageNo, requestParameters.pageSize, requestParameters.supportChatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetAdminSupportCount(options?: RawAxiosRequestConfig): AxiosPromise<SupportChatCount> {
            return localVarFp.chatApiGetAdminSupportCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetChatCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatCount(requestParameters: ChatApiApiChatApiGetChatCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLatestChatCount> {
            return localVarFp.chatApiGetChatCount(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetChatGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatGroup(requestParameters: ChatApiApiChatApiGetChatGroupRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GroupChatListResponse> {
            return localVarFp.chatApiGetChatGroup(requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetChatGroupUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatGroupUsers(requestParameters: ChatApiApiChatApiGetChatGroupUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChatGroupUsersResponse>> {
            return localVarFp.chatApiGetChatGroupUsers(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetChatLogsEmployerApplicantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatLogsEmployerApplicant(requestParameters: ChatApiApiChatApiGetChatLogsEmployerApplicantRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminChatLogsResponse> {
            return localVarFp.chatApiGetChatLogsEmployerApplicant(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetChatMessage(requestParameters: ChatApiApiChatApiGetChatMessageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageListResponse> {
            return localVarFp.chatApiGetChatMessage(requestParameters.chatGroupId, requestParameters.cursor, requestParameters.gameId, requestParameters.jobId, requestParameters.orgId, requestParameters.pageSize, requestParameters.roomId, requestParameters.supportChatId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetEmployerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetEmployerList(requestParameters: ChatApiApiChatApiGetEmployerListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEmployerListResponse> {
            return localVarFp.chatApiGetEmployerList(requestParameters.companyName, requestParameters.email, requestParameters.employerId, requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetFrontChatListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetFrontChatList(requestParameters: ChatApiApiChatApiGetFrontChatListRequest, options?: RawAxiosRequestConfig): AxiosPromise<LatestChatListResponse> {
            return localVarFp.chatApiGetFrontChatList(requestParameters.orgId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiGetSupportChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiGetSupportChat(requestParameters: ChatApiApiChatApiGetSupportChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportChatListResponse> {
            return localVarFp.chatApiGetSupportChat(requestParameters.orgId, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiInitiateChatSupportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiInitiateChatSupport(requestParameters: ChatApiApiChatApiInitiateChatSupportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.chatApiInitiateChatSupport(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiMarkChatSeenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiMarkChatSeen(requestParameters: ChatApiApiChatApiMarkChatSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.chatApiMarkChatSeen(requestParameters.markSeenChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiResolveSupportChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiResolveSupportChat(requestParameters: ChatApiApiChatApiResolveSupportChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.chatApiResolveSupportChat(requestParameters.supportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiSendBlockChatStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendBlockChatStatus(requestParameters: ChatApiApiChatApiSendBlockChatStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatBlockStatusResponse> {
            return localVarFp.chatApiSendBlockChatStatus(requestParameters.chatBlockStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiSendBulkTemplateMessagesByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendBulkTemplateMessagesByAdmin(requestParameters: ChatApiApiChatApiSendBulkTemplateMessagesByAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkTemplateSupportResponse> {
            return localVarFp.chatApiSendBulkTemplateMessagesByAdmin(requestParameters.bulkTemplateSupportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiSendChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendChatMessage(requestParameters: ChatApiApiChatApiSendChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.chatApiSendChatMessage(requestParameters.chatMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiSendMsgOrgOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiSendMsgOrgOwner(requestParameters: ChatApiApiChatApiSendMsgOrgOwnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMessageResponse>> {
            return localVarFp.chatApiSendMsgOrgOwner(requestParameters.sendMsgOrgOwnerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiUnassignChatGroupAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiUnassignChatGroupAdmin(requestParameters: ChatApiApiChatApiUnassignChatGroupAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.chatApiUnassignChatGroupAdmin(requestParameters.groupId, requestParameters.memberUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiUpdateChatGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiUpdateChatGroup(requestParameters: ChatApiApiChatApiUpdateChatGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChatGroupUsersResponse>> {
            return localVarFp.chatApiUpdateChatGroup(requestParameters.groupId, requestParameters.orgId, requestParameters.updateChatGroupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatApiApiChatApiUpdateChatMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatApiUpdateChatMsg(requestParameters: ChatApiApiChatApiUpdateChatMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.chatApiUpdateChatMsg(requestParameters.chatId, requestParameters.updateChatMessageBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for chatApiAdminInitiateChatSupport operation in ChatApiApi.
 */
export interface ChatApiApiChatApiAdminInitiateChatSupportRequest {
    readonly employerId: string

    readonly orgId: string

    readonly adminInitiateSupportBody: AdminInitiateSupportBody
}

/**
 * Request parameters for chatApiAssignChatGroupAdmin operation in ChatApiApi.
 */
export interface ChatApiApiChatApiAssignChatGroupAdminRequest {
    readonly groupId: string

    readonly memberUserId: string
}

/**
 * Request parameters for chatApiCreateChatGroup operation in ChatApiApi.
 */
export interface ChatApiApiChatApiCreateChatGroupRequest {
    readonly orgId: string

    readonly createChatGroupBody: CreateChatGroupBody
}

/**
 * Request parameters for chatApiDeleteChatMsg operation in ChatApiApi.
 */
export interface ChatApiApiChatApiDeleteChatMsgRequest {
    readonly chatId: string
}

/**
 * Request parameters for chatApiExitChatGroup operation in ChatApiApi.
 */
export interface ChatApiApiChatApiExitChatGroupRequest {
    readonly groupId: string
}

/**
 * Request parameters for chatApiGetAccountSupportChat operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetAccountSupportChatRequest {
    readonly pageNo?: number | null

    readonly pageSize?: number | null
}

/**
 * Request parameters for chatApiGetAdminSupportChatMessage operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetAdminSupportChatMessageRequest {
    readonly companyName?: string | null

    readonly isResolved?: boolean | null

    readonly pageNo?: number | null

    readonly pageSize?: number | null

    readonly supportChatId?: string | null
}

/**
 * Request parameters for chatApiGetChatCount operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetChatCountRequest {
    readonly orgId: string
}

/**
 * Request parameters for chatApiGetChatGroup operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetChatGroupRequest {
    readonly pageNo?: number | null

    readonly pageSize?: number | null
}

/**
 * Request parameters for chatApiGetChatGroupUsers operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetChatGroupUsersRequest {
    readonly groupId: string
}

/**
 * Request parameters for chatApiGetChatLogsEmployerApplicant operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetChatLogsEmployerApplicantRequest {
    readonly page?: number | null

    readonly pageSize?: number | null

    readonly searchQuery?: string | null
}

/**
 * Request parameters for chatApiGetChatMessage operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetChatMessageRequest {
    readonly chatGroupId?: string | null

    readonly cursor?: string | null

    readonly gameId?: string | null

    readonly jobId?: string | null

    readonly orgId?: string | null

    readonly pageSize?: number | null

    readonly roomId?: string | null

    readonly supportChatId?: string | null

    readonly userId?: string | null
}

/**
 * Request parameters for chatApiGetEmployerList operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetEmployerListRequest {
    readonly companyName?: string | null

    readonly email?: string | null

    readonly employerId?: string | null

    readonly name?: string | null

    readonly pageNo?: number | null

    readonly pageSize?: number | null
}

/**
 * Request parameters for chatApiGetFrontChatList operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetFrontChatListRequest {
    readonly orgId: string

    readonly pageNo?: number | null

    readonly pageSize?: number | null

    readonly searchQuery?: string | null
}

/**
 * Request parameters for chatApiGetSupportChat operation in ChatApiApi.
 */
export interface ChatApiApiChatApiGetSupportChatRequest {
    readonly orgId: string

    readonly pageNo?: number | null

    readonly pageSize?: number | null
}

/**
 * Request parameters for chatApiInitiateChatSupport operation in ChatApiApi.
 */
export interface ChatApiApiChatApiInitiateChatSupportRequest {
    readonly orgId: string
}

/**
 * Request parameters for chatApiMarkChatSeen operation in ChatApiApi.
 */
export interface ChatApiApiChatApiMarkChatSeenRequest {
    readonly markSeenChatBody: MarkSeenChatBody
}

/**
 * Request parameters for chatApiResolveSupportChat operation in ChatApiApi.
 */
export interface ChatApiApiChatApiResolveSupportChatRequest {
    readonly supportId: string
}

/**
 * Request parameters for chatApiSendBlockChatStatus operation in ChatApiApi.
 */
export interface ChatApiApiChatApiSendBlockChatStatusRequest {
    readonly chatBlockStatusBody: ChatBlockStatusBody
}

/**
 * Request parameters for chatApiSendBulkTemplateMessagesByAdmin operation in ChatApiApi.
 */
export interface ChatApiApiChatApiSendBulkTemplateMessagesByAdminRequest {
    readonly bulkTemplateSupportBody: BulkTemplateSupportBody
}

/**
 * Request parameters for chatApiSendChatMessage operation in ChatApiApi.
 */
export interface ChatApiApiChatApiSendChatMessageRequest {
    readonly chatMessageBody: ChatMessageBody
}

/**
 * Request parameters for chatApiSendMsgOrgOwner operation in ChatApiApi.
 */
export interface ChatApiApiChatApiSendMsgOrgOwnerRequest {
    readonly sendMsgOrgOwnerBody: SendMsgOrgOwnerBody
}

/**
 * Request parameters for chatApiUnassignChatGroupAdmin operation in ChatApiApi.
 */
export interface ChatApiApiChatApiUnassignChatGroupAdminRequest {
    readonly groupId: string

    readonly memberUserId: string
}

/**
 * Request parameters for chatApiUpdateChatGroup operation in ChatApiApi.
 */
export interface ChatApiApiChatApiUpdateChatGroupRequest {
    readonly groupId: string

    readonly orgId: string

    readonly updateChatGroupBody: UpdateChatGroupBody
}

/**
 * Request parameters for chatApiUpdateChatMsg operation in ChatApiApi.
 */
export interface ChatApiApiChatApiUpdateChatMsgRequest {
    readonly chatId: string

    readonly updateChatMessageBody: UpdateChatMessageBody
}

/**
 * ChatApiApi - object-oriented interface
 */
export class ChatApiApi extends BaseAPI {
    /**
     * 
     * @param {ChatApiApiChatApiAdminInitiateChatSupportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiAdminInitiateChatSupport(requestParameters: ChatApiApiChatApiAdminInitiateChatSupportRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiAdminInitiateChatSupport(requestParameters.employerId, requestParameters.orgId, requestParameters.adminInitiateSupportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiAssignChatGroupAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiAssignChatGroupAdmin(requestParameters: ChatApiApiChatApiAssignChatGroupAdminRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiAssignChatGroupAdmin(requestParameters.groupId, requestParameters.memberUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiCreateChatGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiCreateChatGroup(requestParameters: ChatApiApiChatApiCreateChatGroupRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiCreateChatGroup(requestParameters.orgId, requestParameters.createChatGroupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiDeleteChatMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiDeleteChatMsg(requestParameters: ChatApiApiChatApiDeleteChatMsgRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiDeleteChatMsg(requestParameters.chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiExitChatGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiExitChatGroup(requestParameters: ChatApiApiChatApiExitChatGroupRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiExitChatGroup(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetAccountSupportChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetAccountSupportChat(requestParameters: ChatApiApiChatApiGetAccountSupportChatRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetAccountSupportChat(requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetAccountSupportCount(options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetAccountSupportCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetAdminSupportChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetAdminSupportChatMessage(requestParameters: ChatApiApiChatApiGetAdminSupportChatMessageRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetAdminSupportChatMessage(requestParameters.companyName, requestParameters.isResolved, requestParameters.pageNo, requestParameters.pageSize, requestParameters.supportChatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetAdminSupportCount(options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetAdminSupportCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetChatCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetChatCount(requestParameters: ChatApiApiChatApiGetChatCountRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetChatCount(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetChatGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetChatGroup(requestParameters: ChatApiApiChatApiGetChatGroupRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetChatGroup(requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetChatGroupUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetChatGroupUsers(requestParameters: ChatApiApiChatApiGetChatGroupUsersRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetChatGroupUsers(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetChatLogsEmployerApplicantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetChatLogsEmployerApplicant(requestParameters: ChatApiApiChatApiGetChatLogsEmployerApplicantRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetChatLogsEmployerApplicant(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetChatMessage(requestParameters: ChatApiApiChatApiGetChatMessageRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetChatMessage(requestParameters.chatGroupId, requestParameters.cursor, requestParameters.gameId, requestParameters.jobId, requestParameters.orgId, requestParameters.pageSize, requestParameters.roomId, requestParameters.supportChatId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetEmployerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetEmployerList(requestParameters: ChatApiApiChatApiGetEmployerListRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetEmployerList(requestParameters.companyName, requestParameters.email, requestParameters.employerId, requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetFrontChatListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetFrontChatList(requestParameters: ChatApiApiChatApiGetFrontChatListRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetFrontChatList(requestParameters.orgId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiGetSupportChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiGetSupportChat(requestParameters: ChatApiApiChatApiGetSupportChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiGetSupportChat(requestParameters.orgId, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiInitiateChatSupportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiInitiateChatSupport(requestParameters: ChatApiApiChatApiInitiateChatSupportRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiInitiateChatSupport(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiMarkChatSeenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiMarkChatSeen(requestParameters: ChatApiApiChatApiMarkChatSeenRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiMarkChatSeen(requestParameters.markSeenChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiResolveSupportChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiResolveSupportChat(requestParameters: ChatApiApiChatApiResolveSupportChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiResolveSupportChat(requestParameters.supportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiSendBlockChatStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiSendBlockChatStatus(requestParameters: ChatApiApiChatApiSendBlockChatStatusRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiSendBlockChatStatus(requestParameters.chatBlockStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiSendBulkTemplateMessagesByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiSendBulkTemplateMessagesByAdmin(requestParameters: ChatApiApiChatApiSendBulkTemplateMessagesByAdminRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiSendBulkTemplateMessagesByAdmin(requestParameters.bulkTemplateSupportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiSendChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiSendChatMessage(requestParameters: ChatApiApiChatApiSendChatMessageRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiSendChatMessage(requestParameters.chatMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiSendMsgOrgOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiSendMsgOrgOwner(requestParameters: ChatApiApiChatApiSendMsgOrgOwnerRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiSendMsgOrgOwner(requestParameters.sendMsgOrgOwnerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiUnassignChatGroupAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiUnassignChatGroupAdmin(requestParameters: ChatApiApiChatApiUnassignChatGroupAdminRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiUnassignChatGroupAdmin(requestParameters.groupId, requestParameters.memberUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiUpdateChatGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiUpdateChatGroup(requestParameters: ChatApiApiChatApiUpdateChatGroupRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiUpdateChatGroup(requestParameters.groupId, requestParameters.orgId, requestParameters.updateChatGroupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatApiApiChatApiUpdateChatMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatApiUpdateChatMsg(requestParameters: ChatApiApiChatApiUpdateChatMsgRequest, options?: RawAxiosRequestConfig) {
        return ChatApiApiFp(this.configuration).chatApiUpdateChatMsg(requestParameters.chatId, requestParameters.updateChatMessageBody, options).then((request) => request(this.axios, this.basePath));
    }
}

